export default __webpack_public_path__ + "static/media/logo_2.ff8e2f75.png";